var style = {"z-skeleton":"z-skeleton","z-anim-skeleton-pulse":"z-anim-skeleton-pulse","z-skeleton--circle":"z-skeleton--circle"};

export { style as default };
//# sourceMappingURL=Skeleton.module.scss.js.map
